
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/past-continuous-explanation';
const mainimage = '/Images/pastcont1.webp.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "pastcontinuous" },
];

const PastContinuous = () => (
  <GrammarPageLayout
    level="A2"
    title="Past Continuous"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Past Continuous Exercises"
    seoDescription="Describe ongoing actions in the past and contrast with simple past. A2 level practice exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="A2"
  />
);

export default PastContinuous;

